import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { api } from '../../api/client'
import type { AppSummary } from '../../api/types'
import { useMeta } from '../../hooks/useMeta'
import { AppCell } from '../AppCell'
import { AppPicker } from '../compare/AppPicker'

interface Entry {
	id: number
	appId: number
	name: string
	iconUrl: string | null
	developerName: string | null
	storefront: string | null
	addedBy: string | null
}

export function WatchlistPanel() {
	const client = useQueryClient()
	const { data: meta } = useMeta()
	const [storefront, setStorefront] = useState('')
	const list = useQuery({ queryKey: ['watchlist'], queryFn: () => api.get<Entry[]>('/api/admin/watchlist') })
	const refresh = () => client.invalidateQueries({ queryKey: ['watchlist'] })
	const add = useMutation({
		mutationFn: (app: AppSummary) =>
			api.post('/api/admin/watchlist', { appId: app.id, storefront: storefront || null }),
		onSuccess: refresh,
	})
	const remove = useMutation({
		mutationFn: (id: number) => api.delete(`/api/admin/watchlist/${id}`),
		onSuccess: refresh,
	})
	return (
		<section className="card stack">
			<div>
				<h2 style={{ margin: 0 }}>Review watchlist</h2>
				<p className="muted small" style={{ margin: 0 }}>
					Reviews for these apps are collected daily even when they aren’t in a top-10 spot.
				</p>
			</div>
			<div className="row">
				<select aria-label="Watchlist country" value={storefront} onChange={(e) => setStorefront(e.target.value)}>
					<option value="">Every country</option>
					{meta?.storefronts.map((s) => (
						<option key={s.code} value={s.code}>
							{s.name}
						</option>
					))}
				</select>
				<div style={{ flex: 1 }}>
					<AppPicker apps={[]} onAdd={(app) => add.mutate(app)} onRemove={() => {}} />
				</div>
			</div>
			{add.isError && <p className="error small">{add.error.message}</p>}
			<table>
				<tbody>
					{list.data?.map((w) => (
						<tr key={w.id}>
							<td style={{ maxWidth: 0, width: '100%' }}>
								<AppCell app={{ id: w.appId, name: w.name, iconUrl: w.iconUrl, developerName: w.developerName }} />
							</td>
							<td className="small">{w.storefront?.toUpperCase() ?? 'All countries'}</td>
							<td>
								<button type="button" className="danger" onClick={() => remove.mutate(w.id)}>
									Remove
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</section>
	)
}
